"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

exports.__esModule = true;

var react_1 = __importDefault(require("react"));

exports.SVG = function () {
  return react_1["default"].createElement("svg", {
    viewBox: "0 0 20 20",
    fill: "none"
  }, react_1["default"].createElement("path", {
    d: "M16 3.00024H4C2.896 3.00024 2 3.89724 2 5.00424V12.0212C2 13.1272 2.896 14.0242 4 14.0242H11.586C11.851 14.0242 12.105 14.1302 12.293 14.3182L14.097 16.7932C14.382 17.1852 15 16.9822 15 16.4982V14.5252C15 14.2492 15.224 14.0242 15.5 14.0242H16C17.104 14.0242 18 13.1272 18 12.0212V5.00424C18 3.89724 17.104 3.00024 16 3.00024Z",
    fill: "#727B7F"
  }));
};